import React from "react";

const Projector = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M13.429 19.429a5.715 5.715 0 1 0-5.715-5.715 5.72 5.72 0 0 0 5.715 5.715Zm-4.572-5.715a4.571 4.571 0 0 1 4.572-4.571 1.143 1.143 0 1 1 0 2.286 2.286 2.286 0 0 0-2.286 2.285 1.143 1.143 0 0 1-2.286 0Zm21.714-3.428h-9.925a8 8 0 1 1-14.435 0H5.43A3.428 3.428 0 0 0 2 13.714v9.143a3.429 3.429 0 0 0 3.429 3.429v1.143a1.143 1.143 0 1 0 2.285 0v-1.143h20.572v1.143a1.143 1.143 0 1 0 2.285 0v-1.143A3.429 3.429 0 0 0 34 22.857v-9.143a3.429 3.429 0 0 0-3.429-3.428ZM29.43 21.714H22.57a1.143 1.143 0 1 1 0-2.285h6.858a1.143 1.143 0 1 1 0 2.285Zm0-4.571h-4.572a1.143 1.143 0 1 1 0-2.286h4.572a1.143 1.143 0 0 1 0 2.286Z"
            fill={fill}
        />
    </svg>
);

export default Projector;
